document.addEventListener('DOMContentLoaded', function() {
  var treatmentCelebritySlider = new Swiper('#treatmentCelebritySlider', {
    slidesPerView: 1.1,
    navigation: {
      nextEl: '.treatment-celebrity-next',
      prevEl: '.treatment-celebrity-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 1.6,
      },
      640: {
        slidesPerView: 2.3,
      },
      820: {
        slidesPerView: 3,
      },
      1440: {
        slidesPerView: 4,
      }
    },
  });
  var relatedTreatmentsSlider = new Swiper('#relatedTreatmentsSlider', {
    slidesPerView: 2,
    navigation: {
      nextEl: '.related-treatments-next',
      prevEl: '.related-treatments-prev',
    },
    pagination: {
      el: '.related-treatments-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 2.3,
      },
      640: {
        slidesPerView: 2.8,
      },
      768: {
        slidesPerView: 3,
      },
      900: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      }
    },
  });

  var relatedTreatments_col1 = new Swiper('#relatedTreatments_col1', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.related-treatments-next',
      prevEl: '.related-treatments-prev',
    },
    pagination: {
      el: '.related-treatments-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  // 初始化每個案例的內部輪播
  function initializeCaseSliders() {
    const caseSliders = document.querySelectorAll('.case-item-slider');
    caseSliders.forEach((slider) => {
      const caseIndex = slider.getAttribute('data-case-slider');
      new Swiper(slider, {
        slidesPerView: 1,
        navigation: {
          nextEl: `.case-item-next[data-case-index="${caseIndex}"]`,
          prevEl: `.case-item-prev[data-case-index="${caseIndex}"]`,
        },
      });
    });
  }

  initializeCaseSliders();

  // 菜單滾動激活功能
  function initializeMenuScroll() {
    const menuItems = document.querySelectorAll('.treatment-menu-item');
    const menuContainer = document.querySelector('.treatment-menu-container');
    const sections = document.querySelectorAll('[id]');

    function scrollMenuItemIntoView(activeItem) {
      if (!menuContainer || !activeItem) return;

      // 使用 getBoundingClientRect 計算相對位置
      const containerRect = menuContainer.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();

      const containerWidth = containerRect.width;
      const containerLeft = containerRect.left;
      const itemLeft = itemRect.left;
      const itemRight = itemRect.right;
      const itemWidth = itemRect.width;

      const currentScroll = menuContainer.scrollLeft;

      // 計算項目相對於容器左邊的位置
      const relativeLeft = itemLeft - containerLeft + currentScroll;
      const relativeRight = relativeLeft + itemWidth;

      let targetScroll = currentScroll;

      // 如果項目在容器左邊，向左滾動
      if (relativeLeft < currentScroll) {
        targetScroll = relativeLeft - 20;
      }
      // 如果項目在容器右邊，向右滾動
      else if (relativeRight > currentScroll + containerWidth) {
        targetScroll = relativeRight - containerWidth + 20;
      }

      // 平滑滾動
      if (targetScroll !== currentScroll) {
        menuContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }
    }

    function updateActiveMenu() {
      let currentActiveId = null;

      // 遍歷所有區塊，找出在視口中的區塊
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        // 如果區塊頂部在視口中或區塊穿過視口頂部
        if (rect.top <= 150 && rect.bottom > 150) {
          currentActiveId = section.id;
        }
      });

      // 更新菜單項的 is-active 類
      menuItems.forEach(item => {
        const href = item.getAttribute('href');
        const targetId = href ? href.substring(1) : null;

        if (targetId === currentActiveId) {
          item.classList.add('is-active');
          // 滾動菜單項到可見位置
          scrollMenuItemIntoView(item);
        } else {
          item.classList.remove('is-active');
        }
      });
    }

    // 監聽滾動事件
    window.addEventListener('scroll', updateActiveMenu, { passive: true });

    // 初始化菜單狀態
    updateActiveMenu();

    // 點擊菜單項時也更新狀態
    menuItems.forEach(item => {
      item.addEventListener('click', function() {
        setTimeout(updateActiveMenu, 100);
      });
    });
  }

  initializeMenuScroll();

});
